import React from 'react';
import { Box, Typography } from '@mui/material';
import LynaAvatar from './LynaAvatar';
import '../cat-theme.css';

interface CatEmptyStateProps {
    message?: string;
}

const CatEmptyState: React.FC<CatEmptyStateProps> = ({
    message = 'No hay nada aquí todavía',
}) => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '300px',
                gap: 2,
                py: 4,
            }}
        >
            <LynaAvatar size={150} animationEnabled={true} />
            <Typography
                variant="h6"
                sx={{
                    color: 'text.secondary',
                    textAlign: 'center',
                    fontStyle: 'italic',
                    mt: 2
                }}
            >
                {message}
            </Typography>
            <Box sx={{ opacity: 0.3, mt: 2 }}>
                <Typography variant="caption">
                    🐾 Los gatitos están esperando... 🐾
                </Typography>
            </Box>
        </Box>
    );
};

export default CatEmptyState;
